var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnBacSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2814 6.775L1.3 6.775C0.706296 6.775 0.225002 6.2937 0.225002 5.7L0.225002 1.3C0.225002 0.706293 0.706295 0.224999 1.3 0.224999L10.5814 0.225L12.087 0.225C12.467 0.225 12.775 0.533047 12.775 0.913043C12.775 1.29304 12.467 1.60109 12.087 1.60109L11.7907 1.60109C10.9986 1.60109 10.3564 2.24324 10.3564 3.03539L10.3564 5.7C10.3564 6.2937 9.8751 6.775 9.2814 6.775Z",
    stroke: "#444444",
    strokeWidth: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 2.59998L3.90039 2.59998C3.18242 2.59998 2.60039 3.18201 2.60039 3.89998V3.89998C2.60039 4.61795 3.18242 5.19998 3.90039 5.19998L10.4004 5.19998",
    stroke: "#444444",
    strokeWidth: 0.45
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBacSmall);
export default __webpack_public_path__ + "static/media/icn_bac-small.241972e6.svg";
export { ForwardRef as ReactComponent };